import React from 'react';
import PropTypes from 'prop-types';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';

const StyledFormControlLabel = styled(MuiFormControlLabel)(({ theme }) => {
  return {
    margin: theme.spacing(1, 0),
  };
});

const FormControlLabel = (props) => {
  return <StyledFormControlLabel {...props} />;
};

FormControlLabel.propTypes = {
  control: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom']),
};

export default FormControlLabel;
